import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const BetWrightBrandIcon = observer(
    'BetWrightBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
        >
            <path
                fill='#fff'
                d='m17.445 7 2.055 7.826L21.39 7H24l-3.098 10.831H18.44l-1.907-7.437-1.892 7.437H12.18L9.065 7h2.592l1.908 7.826L15.636 7'
            />
            <path
                fill='#FFCE00'
                d='M6.978 12.247c1.027-.211 1.875-1.12 1.875-2.485 0-1.445-1.06-2.76-3.13-2.76H0v.022l.976.953L0 8.933v8.9h5.902c2.07 0 3.163-1.299 3.163-2.923 0-1.364-.93-2.484-2.087-2.662v-.001Zm-4.663-3.28h2.903c.782 0 1.272.52 1.272 1.186 0 .665-.49 1.201-1.272 1.201H2.315V8.967ZM5.3 15.868H2.315v-2.55H5.3c.913 0 1.403.585 1.403 1.267 0 .78-.522 1.283-1.403 1.283Z'
            />
        </SvgElement>
    )
);
